import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DocumentLayoutComponent } from './components/document-layout/document-layout.component';

const routes: Routes = [
  {
    path: ':token',
    component: DocumentLayoutComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentRoutingModule {}
